/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Llm_Provider_HelpInputs */



/**
* | output |
* | --- |
* | "Select the AI model used to analyze video and generate AD scripts." |
*
* @param {Llm_Provider_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const llm_provider_help = /** @type {((inputs?: Llm_Provider_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Llm_Provider_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le modèle d'IA utilisé pour analyser la vidéo et générer les scripts publicitaires.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das KI-Modell aus, das zur Videoanalyse und zur Generierung von Werbeskripten verwendet wird.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il modello di intelligenza artificiale da utilizzare per analizzare il video e generare gli script degli annunci pubblicitari.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите модель ИИ, используемую для анализа видео и генерации рекламных сценариев.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el modelo de IA utilizado para analizar el vídeo y generar los guiones publicitarios.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择用于分析视频和生成广告脚本的AI模型。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画を分析して広告スクリプトを生成するために使用するAIモデルを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो का विश्लेषण करने और विज्ञापन स्क्रिप्ट तैयार करने के लिए उपयोग किए जाने वाले एआई मॉडल का चयन करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o modelo de IA usado para analisar o vídeo e gerar os roteiros dos anúncios.")
	return /** @type {LocalizedString} */ ("Select the AI model used to analyze video and generate AD scripts.")
});